import React, { useContext, useEffect, useState } from 'react'
import { Button, Form, InputGroup, Modal, Spinner } from 'react-bootstrap'
import { FaCopy } from 'react-icons/fa'
import { UserContext } from '../../context/user-context'
import axios from 'axios'

export default function EventDoormanModal({ selectedEventForDoorman, showEventDoormanModal, setShowEventDoormanModal }) {
  const [doormanPIN, setDoormanPIN] = useState(null)
  const [loadingDoorManCode, setLoadingDoorManCode] = useState(true)

  const { userToken, user } = useContext(UserContext)

  const handleClose = () => {
    setShowEventDoormanModal(false)
  }

  const handleCreateDoormanPIN = () => {
    setLoadingDoorManCode(true)
    axios
      .post(process.env.REACT_APP_API_BASE_URL + '/wp-json/gnetwork/v1/events/' + selectedEventForDoorman + '/doorman-pin',{}, {
        headers: {
          'Authorization': 'Basic ' + btoa(user.user_login + ':' + userToken),
        },
      })
      .then((res) => {
        setDoormanPIN(res.data.doorman_code)
        console.log(res.data)
      })
      .catch((err) => {
        console.log(err.message)
        alert('Error!! Check Logs.')
      })
      .finally(() => {
        setLoadingDoorManCode(false)
      })
  }

  useEffect(() => {
    if (selectedEventForDoorman) {
      loadEventDoormanPIN()
    }
  }, [selectedEventForDoorman])

  const loadEventDoormanPIN = () => {
    setLoadingDoorManCode(true)
    axios
      .get(process.env.REACT_APP_API_BASE_URL + '/wp-json/gnetwork/v1/events/' + selectedEventForDoorman + '/doorman-pin', {
        headers: {
          'Authorization': 'Basic ' + btoa(user.user_login + ':' + userToken),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        console.log(res.data)
        setDoormanPIN(res.data.doorman_code)
      })
      .catch((err) => {
        console.log(err.message)
        alert('Error!! Check Logs.')
      })
      .finally(() => {
        setLoadingDoorManCode(false)
      })
  }

  return (
    <Modal
      show={showEventDoormanModal}
      onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Event Doorman PIN</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loadingDoorManCode ? (
          <Spinner
            animation='border'
            role='status'>
            <span className='visually-hidden'>Loading...</span>
          </Spinner>
        ) : (
          <>
            {doormanPIN ? (
              <Form>
                <Form.Group className='mb-3'>
                  <InputGroup>
                    <Form.Control readonly value={doormanPIN}/>
                    <Button
                      variant='outline-secondary'
                      onClick={() => {
                        navigator.clipboard.writeText(doormanPIN)
                      }}
                      id='button-addon2'>
                      <FaCopy />
                    </Button>
                  </InputGroup>
                </Form.Group>
              </Form>
            ) : (
              <>
                <p>A doorman PIN enables ticket scanning, order access, and guest list management for an event in the GNetwork mobile app. Deleting or recreating a PIN disables the old one.</p>
                <p>Currently, only one PIN is active at a time; multiple PIN support is coming in the next update.</p>
              </>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="d-grid gap-2">
        <Button
          size="lg"
          disabled={loadingDoorManCode}
          variant='primary'
          onClick={handleCreateDoormanPIN}
        >
          {doormanPIN ? 'Recreate Doorman PIN' : 'Create Doorman PIN'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
